module.exports = __webpack_public_path__ + "static/media/priorities.6de8deee.svg";